import React from 'react';

import { trans } from '../../../../../localization/index';
import Modal, {
  ModalAction,
  ModalBody,
  ModalButton,
  ModalHeader,
} from '../../../../../components/Modal/Modal';
import { EnumRejectOrderReason } from '../../../../../constants/enum';

function MinuteTimeBusy({ time, totalMinute, handleBusyRestaurant }) {
  return (
    <div className="col-4 pl-2 pr-2">
      <div
        className={`item-busy-time ${time === totalMinute ? 'active' : ''}`}
        onClick={() => handleBusyRestaurant(time)}
      >
        {time} {trans('mod_minute')}
      </div>
    </div>
  );
}

function RejectOrderBusyModal({
  isOpenDialog,
  handleRejectOrder,
  handleBusyRestaurant,
  busyInfoOrder,
  setGeneralError,
  handleUpdateOrder,
}) {
  const handleRestaurantBusy = () => {
    const { totalMinute = 0 } = busyInfoOrder;
    if (totalMinute === 0) {
      setGeneralError(trans('mod_choose_time_busy'));
    } else {
      handleUpdateOrder();
    }
  };

  const { totalMinute } = busyInfoOrder;
  const listTimes = [15, 30, 45, 60, 90, 120];
  return (
    <Modal isOpen={isOpenDialog} width="400px" className="res-busy-time">
      <ModalHeader>{trans('mod_how_long_restaurant_busy')}</ModalHeader>
      <ModalBody>
        <div className="row m-0">
          {listTimes.map(time => (
            <MinuteTimeBusy
              key={time}
              time={time}
              totalMinute={totalMinute}
              handleBusyRestaurant={handleBusyRestaurant}
            />
          ))}
        </div>
        {totalMinute > 0 && (
          <div className="res-busy-desc ml-2 mt-2">
            {`${trans('mod_order_new_processing_after')} `}
            <strong>
              {totalMinute} {trans('mod_minute')}
            </strong>
          </div>
        )}
      </ModalBody>
      <ModalAction>
        <ModalButton onClick={handleRestaurantBusy}>
          {trans('common_yes')}
        </ModalButton>
        <ModalButton
          type="cancel"
          onClick={() =>
            handleRejectOrder(EnumRejectOrderReason.CHOOSE_OPTION.id)
          }
        >
          {trans('mod_go_back')}
        </ModalButton>
      </ModalAction>
    </Modal>
  );
}
export default RejectOrderBusyModal;



// WEBPACK FOOTER //
// ./foody/src/pages/Order/OrderManagement/OrderDetail/RejectOrder/RejectOrderBusyModal.jsx